<script setup lang="ts">
import { v4 as uuidv4 } from "uuid";
import RadioButton from "./RadioButton.vue";

interface RadioGroupOption {
  value: string | number;
  label: string;
  disabled?: boolean;
}

withDefaults(
  defineProps<{
    modelValue: string | number | null;
    name: string;
    options: RadioGroupOption[];
    label?: string;
    disabled?: boolean;
    hover?: boolean;
    theme?: "appBlue" | "slate";
  }>(),
  {
    label: undefined,
    disabled: false,
    hover: false,
    theme: "appBlue",
  }
);

const emit = defineEmits<{
  "update:modelValue": [value: string | number];
}>();

const labelId = `radiogroup-label-${uuidv4()}`;

function onChange(payload: { name: string; value: string | number }) {
  emit("update:modelValue", payload.value);
}
</script>

<template>
  <div
    role="radiogroup"
    :aria-labelledby="label ? labelId : undefined"
    class="flex flex-col">
    <p
      v-if="label"
      :id="labelId"
      class="t-small-bold text-type-default mb-px-4">
      {{ label }}
    </p>
    <RadioButton
      v-for="option in options"
      :key="String(option.value)"
      :name="name"
      :label="option.label"
      :value="option.value"
      :checked="modelValue === option.value"
      :disabled="disabled || option.disabled === true"
      :hover="hover"
      :theme="theme"
      @change="onChange" />
  </div>
</template>
